import type { BillingRepository } from '../../repositories/BillingRepository';

export class CreateSubscriptionFromSearchParamsUseCase {
  constructor(private readonly billingRepository: BillingRepository) {}

  async execute(searchParams: URLSearchParams): Promise<boolean> {
    return this.billingRepository.createSubscriptionFromSearchParams(searchParams);
  }
}
